import React, { useEffect, useState } from 'react';
import { FieldArray, useFormikContext } from 'formik';
import { Button, Form } from 'react-bootstrap';
import Plus from 'mdi-react/PlusIcon';
import Minus from 'mdi-react/CloseIcon';
import classNames from 'classnames';

import { trims } from 'utils';
import TitleUndescore from 'modules/shared/TitleUndescore';
import { Input, MultyInput } from 'modules/shared/Forms';
import styles from 'modules/shared/Forms/MultyInput/MultyInput.module.scss';
import classes from '../../../containers/BranchEditing/BranchEditing.module.scss';

type Props = {
  values: any;
  onChange: (e: React.ChangeEvent<any>) => void;
};

const LocationsCard: React.FC<Props> = ({ onChange, values }) => {
  const { setFieldValue } = useFormikContext();
  const { locations } = values;

  const [arrDoubles, setArrDoubles] = useState<number[]>([]);
  const { touched, setFieldTouched } = useFormikContext();

  const checkDoublesRoles = () => {
    const uniqValues = [] as string[];
    const doubles = [] as number[];

    locations.forEach((doc: any, index: number) => {
      const str = trims(`${doc.name}`.toLowerCase());

      if (uniqValues.includes(str)) {
        doubles.push(index);
      } else {
        uniqValues.push(str);
      }
    });

    doubles.forEach((arr: number) => {
      setFieldTouched(`aadRoles[${arr}].objectId`);
    });

    setArrDoubles(doubles);
  };

  useEffect(() => {
    if (locations) checkDoublesRoles();
  }, [locations]);

  return (
    <div className="my-5">
      <TitleUndescore title="Склад / локації" />
      <Form.Group className={classNames(classes.pl35p, 'd-flex flex-row align-items-start')}>
        <FieldArray
          name="locations"
          render={(arrayHelpers) => {
            const addHandler = () => arrayHelpers.push({ name: '', configurations: [{ name: '' }] });
            const removeHandler = (index: number) => setFieldValue(`locations[${index}].isDeleted`, true);

            return (
              <div className="d-flex flex-column w-100 pr-3">
                {locations?.map((v: any, index: number) => {
                  if (v.isDeleted) return;

                  const isExist =
                    !!arrDoubles.length &&
                    !!arrDoubles.find((a: number) => a === index) &&
                    Object.keys(touched).includes('locations') &&
                    // @ts-ignore
                    touched?.locations[index]?.name;

                  return (
                    <div className="d-flex flex-column row position-relative" key={index}>
                      <div className={classNames(classes.pr42, 'd-flex flex-row align-items-center w-100 pl-0 mb-2')}>
                        <Form.Label className="col-4 pl-4 ml-1 mr-2 position-relative">
                          {index === 0 && (
                            <Button
                              variant="success"
                              className={classNames(styles.plus_btn, 'rounded-circle')}
                              onClick={addHandler}
                            >
                              <Plus size="14" />
                            </Button>
                          )}
                          <div style={{ marginLeft: '20px' }}>Локація:</div>
                        </Form.Label>
                        <div className={classNames(styles.pr27, 'col-7 pl-3 position-relative')}>
                          <Input
                            className={classNames(isExist && styles.isInputErr, 'position-relative')}
                            name={`locations[${index}].name`}
                            onChange={onChange}
                          />
                          {isExist && <h5 className={styles.errormsgSMc}>Вже є у списку</h5>}
                        </div>
                        {index > 0 && (
                          <Button
                            variant="danger"
                            className={classNames(styles.minus_btn_local, 'rounded-circle')}
                            onClick={() => removeHandler(index)}
                          >
                            <Minus size={14} />
                          </Button>
                        )}
                        <div className="col-2" />
                      </div>
                      <MultyInput
                        label="SAP-склад; SAP-завод"
                        onChange={onChange}
                        name={`locations[${index}].configurations`}
                        value={locations[index].configurations}
                        paragraph
                      />
                    </div>
                  );
                })}
              </div>
            );
          }}
        />
      </Form.Group>
    </div>
  );
};

export default LocationsCard;
